import { GithubContext } from '@mode/github/contract';
import { createAction, props } from '@ngrx/store';

export const githubSyncContextChanged = createAction(
  '[Github Sync] Context Changed',
  props<{ context: GithubContext }>()
);
